/* eslint-disable max-lines */
import {
    instructionService
} from 'shared/api/services/BEX/instruction.service';
import React, {
    useContext, useEffect, useState
} from 'react';
import {
    useParams
} from 'react-router-dom';
import InstructionCard from './InstructionCard';
import {
    Context
} from 'shared/context/GlobalState';
import AlertModal from 'shared/components/Alertmodal';
import {
    Button
} from 'shared/components/ui/button';
import {
    AppLoader
} from 'shared/components/LoaderSpinner';
import InstructionForm from './InstructionForm';
import {
    Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle
} from 'shared/components/ui/dialog';
import labHelper from 'builders/builderInternal/classes/AILabHelper';
import UpdateInstructionDialog from './UpdateInstruction';
import {
    checkRequiredFields, getParameterType
} from './helper';
import {
    FilterBar, SearchBar
} from './Filters';
import Breadcrumb from 'shared/components/Breadcrumb';
import {
    OrganizationContext
} from 'shared/context/OrganizationContext';
import {
    modelService
} from 'shared/api/services/BEX/models.services';
import {
    buildProviderParametersState
} from '../Common/providerConfigRegistry';

export default function Instructions() {

    const [instructions, setInstructions] = useState([]);
    const [modelProviders, setModelProviders] = useState([]);
    const [selectModelType, setSelectModelType] = useState('All');
    const [modelTypes, setModelTypes] = useState([{
        id: 1,
        name: 'All',
        value: 'All'
    }]);

    const [loading, setLoading] = useState(true);
    const [show, setShow] = useState(false);

    const [updateModal, setUpdateModal] = useState(false);
    const [delModal, setDelModal] = useState(false);
    const [delBtn, setDelBtn] = useState(false);
    const [selectedCard, setSelectedCard] = useState(false);
    const [isCopy, setIsCopy] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');

    const {
        addNewNotifcation
    } = useContext(Context);
    const {
        selectedOrganization
    } = useContext(OrganizationContext);

    const {
        oragID, subOragID
    } = useParams();

    const handleReloadModels = async (hardRefresh = false) => {
        // fetch model providers
        const body = {
            provider: selectedOrganization.providers || [],
            filter: {
                Watson: {
                    region: 'All',
                    showInactive: false
                },
                Groq: {
                    showInactive: false
                },
                OnPrem: {
                    showInactive: false
                },
                Gemini: {
                    showInactive: false
                },
                Cerebras: {
                    showInactive: false
                },
                Mistral: {
                    showInactive: false
                },
                Novita: {
                    showInactive: false
                }
            }
        };
        const res = await modelService.getModels(body, hardRefresh, oragID);
        const models = res.data || [];
        models.sort((a, b) => {
            let providerComparison = a.provider_type.localeCompare(b.provider_type);
            return providerComparison !== 0 ? providerComparison : a.model_id.localeCompare(b.model_id);
        });
        setModelProviders(models);

        return models;
    };

    useEffect(() => {
        const organizationProvider = selectedOrganization?.providers || [];
        setModelTypes(prev => [...prev, ...organizationProvider.map((item, index) => ({
            id: index + 2,
            name: item,
            value: item === 'Watson' ? 'IBM' : item
        }))]);

        const fetchInstructions = async () => {

            const models = await handleReloadModels(false);

            const modelIdSet = new Set(models.map(model => model.model_id));
            instructionService.listModels(oragID, subOragID)
                .then((res) => {
                // check for each instruction if model type is in the model providers
                    const filteredInstructions = res.data.map(item => {
                        const modifiedObj = {
                            ...item,
                            isModelProviderExist: modelIdSet.has(item.modelId)
                        };
                        // update the parameters for IBM model from sampling to sample
                        if (item.model_type === 'IBM' && item.parameters?.decoding_method === 'sampling') {
                            modifiedObj.parameters = {
                                ...item.parameters,
                                decoding_method: 'sample'
                            };
                        }
                        // handle OnPrem parameters if needed
                        if (item.model_type === 'OnPrem' && item.parameters) {
                            modifiedObj.parameters = {
                                ...item.parameters,
                            };
                        }

                        return modifiedObj;
                    });
                    filteredInstructions.sort((a, b) => new Date(b.modified_timestamp || b.creation_timestamp) - new Date(a.modified_timestamp || a.creation_timestamp));
                    setInstructions(filteredInstructions);
                }).catch(() => {

                }).finally(() => {
                    setLoading(false);
                });
        };
        fetchInstructions();

    }, []);

    const handleDeleteInstruction = () => {
        setDelBtn(true);

        const delObj = {
            org_id: oragID,
            sub_org_id: subOragID,
            model_type: selectedCard.model_type,
            unique_names: [selectedCard.unique_name],
        };
        instructionService.deleteModels(delObj)
            .then((res) => {
            //
                const uniqueName = res.data.find(item => item.unique_name);
                if (uniqueName && uniqueName?.status === 200) {
                    addNewNotifcation('Instruction deleted successfully', 'success');
                    setInstructions(prev => prev.filter(item => item.unique_name !== selectedCard.unique_name));
                    setDelModal(false);
                } else if (uniqueName && uniqueName?.status === 409) {
                    addNewNotifcation(`Failed to delete instruction. ${uniqueName.reason || 'This instruction is linked to opcodes'}`, 'danger');
                } else {
                    addNewNotifcation('Failed to delete instruction. Something went wrong', 'danger');
                }
            }).catch(() => {

                addNewNotifcation('Something went wrong. Please try again', 'danger');
            }).finally(() => {
                setDelBtn(false);
            });
    };

    const getFilteredList = () => {
        return instructions.filter(item =>
            item.unique_name?.toLowerCase()?.includes((searchTerm.toLowerCase())) &&
            (selectModelType === 'All' || item.model_type === selectModelType));
    };

    // Handle search term change
    const handleSearch = (value) => {
        setSearchTerm(value);
    };

    // Handle search term change
    const handleType = (value) => {
        setSelectModelType(value);
    };

    const handleOnUpdateSuccess = (updatedInstruction) => {
        if (isCopy) {
            setInstructions(prev => ([updatedInstruction, ...prev]));
        } else {
            setInstructions(prev => prev.map((item) => item.unique_name === selectedCard.unique_name ? updatedInstruction : item));
        }
    };

    if (loading) {
        return <div className='flex flex-grow flex-col justify-center items-center'> <AppLoader size={50} /> </div>;
    }

    return (
        <div className='flex flex-col w-full h-full p-8 overflow-y-scroll'>
            <div className='my-3 px-2'>
                <Breadcrumb maxPaths={2} />
            </div>
            <div className='flex flex-col w-full my-4 p-2'>
                <div className="flex justify-between items-center mb-8">
                    <h1 className="text-3xl font-bold">Instructions</h1>
                    <Button onClick={() => setShow(true)}> Add new instruction </Button>
                </div>
                <div className="mb-6 flex flex-col sm:flex-row gap-4 items-center">
                    <div className="flex-grow">
                        <SearchBar onSearch={handleSearch} />
                    </div>
                    <FilterBar
                        onSearch={handleType}
                        selectModelType={selectModelType}
                        types={modelTypes}
                    />
                </div>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                {getFilteredList().length > 0 ?
                    getFilteredList().map((item) => (
                        <InstructionCard
                            selectedOrganization={selectedOrganization}
                            key={item._id}
                            {...item}
                            onManage={() => {
                                setSelectedCard(item);
                                setUpdateModal(true);
                                setIsCopy(false);
                            }}
                            onCopy={() => {
                                setIsCopy(true);
                                setSelectedCard(item);
                                setUpdateModal(true);
                            }}
                            onDelete={() => {
                                setSelectedCard(item);
                                setDelModal(true);
                            }}
                        />
                    )) :
                    <p className="px-4">No instructions found.</p>
                }
            </div>

            {/* create new instruction dialog */}
            <CreateNewInstructionDialog
                handleReloadModels={handleReloadModels}
                modelProviders={modelProviders}
                openModal={show}
                setOpenModal={setShow}
                setInstructions={setInstructions} />

            {/* update instruction dialog */}
            <UpdateInstructionDialog
                handleReloadModels={handleReloadModels}
                modelProviders={modelProviders}
                copy={isCopy} selectedCard={selectedCard}
                openModal={updateModal} setOpenModal={setUpdateModal}
                onSuccess={handleOnUpdateSuccess} // set instructions state on success
            />

            {/* delete instruction modal */}
            <AlertModal loading={delBtn} openModal={delModal} setopenModal={setDelModal} onDelete={handleDeleteInstruction} />
        </div>
    );
}

const CreateNewInstructionDialog = ({
    setInstructions, openModal, setOpenModal, handleReloadModels, modelProviders
}) => {

    const getInitialInstructionForm = () => ({

        unique_name: '',
        model_type: '',
        modelDescription:'',
        selectedModel: '',

        instruction: '',
        context: '',
        targetFormat: '',
        sampleInput: '',
        sampleOutput: '',
        inputData: '',

        ...buildProviderParametersState()
    });

    const [instructionForm, setInstructionForm] = useState(getInitialInstructionForm);
    const [btnLoading, setBtnLoading] = useState(false);

    const {
        oragID, subOragID
    } = useParams();
    const {
        addNewNotifcation, user
    } = useContext(Context);

    const handleCreateInstruction = () => {
        const requiredFields = [
            {
                field: 'model_type',
                name: 'model type'
            },
            {
                field: 'unique_name',
                name: 'unique name'
            },
            {
                field: 'modelId',
                name: 'model'
            },
        ];

        const instructionObj = {
            model_type: instructionForm.model_type,
            unique_name: instructionForm.unique_name,
            modelId: instructionForm.selectedModel,
            prompt: labHelper.ConstructPromptUnified({
                instruction: instructionForm.instruction.trim(),
                context: instructionForm.context.trim(),
                target_format: instructionForm.targetFormat.trim(),
                sample_input: instructionForm.sampleInput.trim(),
                sample_output: instructionForm.sampleOutput.trim(),
            }),
            parameters: getParameterType(instructionForm),
            org_id: oragID,
            sub_org_id: subOragID,
            modelDescription: instructionForm.modelDescription,
            user_id: user._id,
            metadata: {}
        };

        // add ibm api connectors
        if (instructionForm.model_type === 'IBM') {
            if (instructionForm.api_key_id && instructionForm.level_type) {
                instructionObj['api_key_id'] = instructionForm.api_key_id;
                instructionObj['level_type'] = instructionForm.level_type;
            }
        }

        // add OnPrem specific fields
        if (instructionForm.model_type === 'OnPrem') {
            if (instructionForm.fullModelData) {
                instructionObj['api_key'] = instructionForm.fullModelData.api_key || instructionForm.fullModelData.apiKey;
                instructionObj['base_url'] = instructionForm.fullModelData.base_url || instructionForm.fullModelData.baseUrl || instructionForm.fullModelData.url;
            }
        }

        const checkFields = checkRequiredFields(instructionObj, requiredFields);
        if (!checkFields.isValid) {
            return addNewNotifcation(`Please fill in all required fields: ${checkFields.missingFields.map(item => (item.name)).join(', ')}`, 'warning');
        } else if (!instructionForm.instruction || instructionForm.instruction.trim() === '') {
            return addNewNotifcation('Please fill in all required fields: instruction', 'warning');
        }

        setBtnLoading(true);

        instructionService.createModel(instructionObj)
            .then((res) => {
            //
                addNewNotifcation('Instruction created successfully', 'success');
                setInstructions(prev => ([res.data, ...prev]));

                setInstructionForm(getInitialInstructionForm());
                setOpenModal(false);
            }).catch((error) => {

                if (error.response?.status === 409) {
                    addNewNotifcation(`Instruction with ${instructionForm.unique_name} already exists`, 'danger');
                } else {
                    addNewNotifcation('Something went wrong. Please try again', 'danger');
                }
            }).finally(() => {
                setBtnLoading(false);
            });
    };

    return (
        <Dialog open={openModal} onOpenChange={setOpenModal}>
            <DialogContent className="max-w-[850px] w-full">
                <DialogHeader>
                    <DialogTitle className="text-2xl font-semibold">Create New Instruction</DialogTitle>
                    <DialogDescription className="text-md text-muted-foreground">Set up a new instruction.</DialogDescription>
                </DialogHeader>

                <InstructionForm
                    modelProviders={modelProviders}
                    handleReloadModels={handleReloadModels}
                    form={instructionForm}
                    setForm={setInstructionForm}
                    update={false} />

                <DialogFooter className="flex justify-end space-x-5 mt-6">
                    <Button variant="outline" onClick={() => setOpenModal(false)} className="px-5 py-3 size-md border-solid shadow-none text-accent-foreground">Cancel</Button>
                    <Button
                        disabled={btnLoading || labHelper.validateUniqueName(instructionForm.unique_name).isValid === false}
                        onClick={handleCreateInstruction}
                        className="px-5 py-3 text-md"
                    >
                        {btnLoading ? 'Creating instruction...' : 'Create instruction'}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
};
